var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPleatsHidden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1895 12.37C34.7939 9.33862 44.3793 9.08519 62.1776 12.37",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 59.5C14.1999 32.7477 13.9058 13.8022 16.4438 9.75146C19.3236 13.7288 20.7253 16.1385 22.0296 21.4467C21.4124 35.995 21.342 44.4009 21.3314 59.5",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1713 59.3252C24.4769 42.9727 23.9483 34.2293 22.0293 21.6211",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6182 9.75157C20.2767 7.51954 22.3948 6.26788 30.7572 3.99121",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.541 59.5C66.3411 32.7477 66.6352 13.8022 64.0972 9.75146C61.2174 13.7288 59.8157 16.1385 58.5114 21.4467C59.1286 35.995 59.199 44.4009 59.2097 59.5",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3697 59.3252C56.0641 42.9727 56.5927 34.2293 58.5117 21.6211",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9229 9.75157C60.2644 7.51954 58.1462 6.26788 49.7838 3.99121",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1538 0.5C31.4232 1.7906 31.1041 2.61456 30.7573 4.34024C38.586 6.65588 42.5716 6.26183 49.784 3.99112C49.1436 2.54621 48.7927 1.7911 47.6893 0.5C41.8842 2.07307 38.4699 2.04591 32.1538 0.5Z",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0415 22.1452C39.1362 20.0506 39.453 16.4943 39.1362 11.3228",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0439 22.8435C41.0156 18.9178 40.6798 16.4943 40.9966 11.3228",
    stroke: "#999999",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPleatsHidden);
export default __webpack_public_path__ + "static/media/pleats_hidden.d20546ccb35c14c2d3e80e2e89be0fbe.svg";
export { ForwardRef as ReactComponent };